import React, { useEffect } from 'react';
import { mapValues, } from 'lodash';

import Field from '../Field';
import useFormState from '../hooks/useFormState';

const { entries, } = Object;

export default function PendingItemForm (props) {
  const { fields, values, onChange, } = props;
  const statedFields = useFormState(values, fields, values);
  useEffect(() => {
    onChange({
      ...mapValues(statedFields, 'value'),
      isValid: Object.values(statedFields).every(_ => _.isValid),
    });
  }, [...Object.values(statedFields).map(_ => _.value)]);

  return (
    <div>
      <div className="d-flex">
        {
          entries(statedFields).map(([fieldName, fieldSetting]) => (
            <div className="mr-2" style={{ minWidth: ({ boxSize: 150, quantity: 80 })[fieldName], }}>
              <Field
                key={fieldName}
                name={fieldName}
                {...fieldSetting}
              />
            </div>
          ))
        }
      </div>
    </div>
  );
}
